<ng-container
  *ngIf="
    controllers | findProperty : propFilterFunction : null : true as windowProps
  "
>
  <ng-container
    *ngIf="
      controllers
        | findProperty
          : Property.isIgnoreWindow
          : null
          : true as ignoreWindowProps
    "
  >
    <!-- NO FORCE PROP INDEX -->
    <div *ngIf="forcePropIndex === -1">
      <ng-container *ngFor="let windowProp of windowProps">
        <!-- WINDOW IGNORED -->
        @if(ignoreWindowProps | propIsActive) {
        <div
          class="status-container-small flex-row-center-v margin-bottom12 width230 ignored"
        >
          <div
            [ngClass]="iconInactive"
            class="icon-background-off font-size19"
          ></div>
          <div class="status-text-off">
            {{ windowProp.name + " " + "ignored" | translate }}
          </div>
        </div>
        }
        <!-- WINDOW ACTIVE -->
        @else if(windowProp | propIsActive) {
        <div
          class="status-container-small flex-row-center-v margin-bottom12 width230"
        >
          <div
            [ngClass]="iconActive"
            class="icon-background-on font-size19"
          ></div>
          <div class="status-text-on">
            {{ windowProp.name + " " + activeSufix | translate }}
          </div>
        </div>
        } @else {
        <!-- WINDOW NOT ACTIVE -->
        <div
          class="status-container-small flex-row-center-v margin-bottom12 width230"
        >
          <div
            [ngClass]="iconInactive"
            class="icon-background-off font-size19"
          ></div>
          <div class="status-text-off">
            {{ windowProp.name + " " + inactiveSufix | translate }}
          </div>
        </div>
        }
      </ng-container>
    </div>
    <!-- FORCE PROP INDEX -->
    <ng-container *ngIf="forcePropIndex != -1">
      <!-- WINDOW IGNORED -->
      @if(ignoreWindowProps | propIsActive) {
      <div
        class="status-container-small flex-row-center-v margin-bottom12 width230 ignored"
      >
        <div
          [ngClass]="iconInactive"
          class="icon-background-off font-size19"
        ></div>
        <div class="status-text-off">
          {{ windowProps[forcePropIndex]?.name + " " + "ignored" | translate }}
        </div>
      </div>
      }
      <!-- WINDOW ACTIVE -->
      @else if(windowProps[forcePropIndex] | propIsActive) {
      <div
        class="status-container-small flex-row-center-v margin-bottom12 width230"
      >
        <div
          [ngClass]="iconActive"
          class="icon-background-on font-size19"
        ></div>
        <div class="status-text-on">
          {{
            windowProps[forcePropIndex]?.name + " " + activeSufix | translate
          }}
        </div>
      </div>
      } @else {
      <!-- WINDOW NOT ACTIVE -->
      <div
        class="status-container-small flex-row-center-v margin-bottom12 width230"
      >
        <div
          [ngClass]="iconInactive"
          class="icon-background-off font-size19"
        ></div>
        <div class="status-text-off">
          {{
            windowProps[forcePropIndex]?.name + " " + inactiveSufix | translate
          }}
        </div>
      </div>
      }
    </ng-container>
  </ng-container>
</ng-container>
